import { SimulatorForm } from "components/retirement/simulator-form";
import LandingSection from "components/common/landing-section";
import schema from "data/schema/retirement-planning.json";

import { useAtomValue } from "lib/global-context";
import useSendHeightToParent from "hooks/useSendHeightToParent";
import { currentStepAtom } from "lib/atoms";
import PageContainer from "components/common/page-container";

export default function Home() {
  useSendHeightToParent();

  const setCurrentStep = useAtomValue(currentStepAtom);

  const { title, description, ctaButtonText, imageSrc } =
    schema.questionnaire.displayConfiguration;
  const questions = schema.questionnaire.questions;

  return (
    <PageContainer page="retirement">
      {setCurrentStep === 0 ? (
        <LandingSection
          page="retirement"
          imageSrc={imageSrc}
          headline={title}
          body={description}
          buttonText={ctaButtonText}
        />
      ) : (
        <SimulatorForm questions={questions} />
      )}
    </PageContainer>
  );
}
